import { IFetchOrderUserSubscriptionsParams } from 'interfaces/userSubscription';
import { cloudFunction } from 'services/parse';

export const fetchUsersSubscriptions = (data: Record<string, any>) => {
  return cloudFunction('fetchUserSubscriptions', data);
};

export const fetchUserSubscriptionDetails = async (userSubscriptionId: string) => {
  let response = await cloudFunction('fetchUserSubscriptionDetails', { userSubscriptionId });
  if (response.notes?.length) {
    response = {
      ...response,
      notes: response.notes.map(note => ({
        ...note,
        by: note.by?.toJSON ? note.by?.toJSON() : undefined,
      })),
    };
  }
  if (response.userLocation) {
    response = {
      ...response,
      userLocation: response.userLocation?.toJSON(),
    };
  }
  return response;
};

export const fetchAllSubscriptions = () => {
  return cloudFunction('fetchAllSubscriptions', {});
};

export const fetchOrdersForUserSubscription = (params: IFetchOrderUserSubscriptionsParams) => {
  return cloudFunction('fetchOrdersForUserSubscription', params);
};

export const getStripeCustomerPortalSession = (userId: string) => {
  return cloudFunction('getStripeCustomerPortalSession', { userId });
};

export const getSampleHomeBox = (id: string, userId: string) => {
  return cloudFunction('getSampleHomeBox', { id, userId });
};

export const updateUserSubscriptionProps = (data: Record<string, any>) => {
  return cloudFunction('updateUserSubscriptionProps', data);
};

export const addNote = (data: Record<string, any>) => {
  return cloudFunction('addNote', data);
};

export const editNote = (data: Record<string, any>) => {
  return cloudFunction('editNote', data);
};

export const deleteNote = (data: Record<string, any>) => {
  return cloudFunction('deleteNote', data);
};

export const createUserSubscription = (data: Record<string, any>) => {
  return cloudFunction('createUserSubscription', data);
};